import React, {useEffect, useState} from "react";
import { useElasticData, useExtraData } from "../DataContext.js";
import Cookies from "js-cookie";

import AnnotationsPanel from './AnnotationsPanel.js';
import AuthorBioPanel from './AuthorBioPanel.js';
import DetailsPanel from './DetailsPanel.js';
import InternalPanel from './InternalPanel.js';
import LevellingPanel from './LevellingPanel.js';
import NotesPanel from './NotesPanel.js';
import ResourcesPanel from './ResourcesPanel.js';
import SeriesPanel from './SeriesPanel.js';

const BookPageTabs = () => {
    
    let { productData, bookBands, productResources, seriesData, bookMatchRatings } = useElasticData();
    let { extraData, _source, isGuestUser, isLibraryUserActual, isSchoolsUser, isInternal } = useExtraData();

    const [tabs, setTabs] = useState([]);
    let sel = Cookies.get("bookPageTab") ?? "tab-1";  

    const tabNo = Number(sel.split("tab-")[1])

    if(tabNo > tabs.length) sel = "tab-1";

    useEffect(() => {
        setTabs(generateTabs());
    }, [productResources, seriesData, productData]);

    useEffect(() => {
        $('.tabContainer').height($('.tabContent.current').height() + 50);
    }, [tabs]);

    const bookbandsArray = _source.productcategorylinks ? _source.productcategorylinks.filter(pcl => bookBands[pcl]) : [];

    const includeBibText = (_source.bib_tag && _source.bib_tag !== "" && _source.bib_tag?.length > 300);

    const generateTabs = () => {
        let _tabs = []
    
        if(_source.annotation || includeBibText || _source.contents){
            _tabs.push("Annotation");
        } else if(isGuestUser || isSchoolsUser){
            _tabs.unshift("Our review");
        }  
        _tabs.push("Details");

        if(bookMatchRatings?.length > 0 || bookbandsArray?.length > 0 || _source.lexiles || _source.lexile_level || _source.book_level || _source.ar_interest_level || _source.quiz_number || _source.points || _source.quiz_date || _source.reading_recovery_level || _source.phonic_phase_level) {
            _tabs.push("Levelling information");
        }

        if(productResources?.length > 0){
            _tabs.push("Resources");
        }

        if(isLibraryUserActual() && seriesData?.length > 0){
            _tabs.push("Series");
        }

        if(isInternal()){
            _tabs.push("Internal");
        }

        if(!isGuestUser){
            _tabs.push(`${extraData?.authname ? extraData?.authname : "My"} notes`);
        }      

        if(_source.author_bio){
            _tabs.push("About the author");
        }

        return _tabs;
    } 
    
    function switchPanel(selectedTab, selectedTabId){
        let tabsSection = selectedTab.closest(".bookInformationSection");

        let productTabs = tabsSection.querySelectorAll(".productTab");
        productTabs.forEach(tab => {
            tab.classList.remove('current');
        });

        let productPanels = tabsSection.querySelectorAll(".tabContent");
        productPanels.forEach(panel => {
            panel.style = "";
            panel.classList.remove('current');
        });

        let selectedPanel = document.querySelector(`#${selectedTabId}`);
        selectedTab.classList.add("current");
        selectedPanel.style.opacity = "1";
        selectedPanel.classList.add("current");

        // document.cookie = "bookPageTab="+selectedTabId+"; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";

        Cookies.set("bookPageTab", selectedTabId, {sameSite: "Strict", path: "/", expires: 253372806925});

        $('.tabContainer').height($('.tabContent.current').height() + 50);
    }

    function selectTab(e){
        switchPanel(e.target, e.target.dataset.tab);
    }

    const getPanel = (tab, index) => {
        switch (tab) {
            case "Our review":
            case "Annotation":
                return <AnnotationsPanel key={index} tabIndex={index} sel={sel} />;
            case "Details":
                return <DetailsPanel key={index} tabIndex={index} sel={sel} />;
            case "Resources":
                return <ResourcesPanel key={index} tabIndex={index} sel={sel} />;
            case "Levelling information":
                return <LevellingPanel key={index} tabIndex={index} sel={sel} />;
            case "Internal":
                return <InternalPanel key={index} tabIndex={index} sel={sel} />;
            case "About the author":
                return <AuthorBioPanel key={index} tabIndex={index} sel={sel} />;
            case "Series":
                return <SeriesPanel key={index} tabIndex={index} sel={sel} />;
            default:
                return <NotesPanel key={index} tabIndex={index} sel={sel} />;
        }
    }

    const Tabs = React.memo(() => {
        return(
            <ul className="productPageTabs">
                {tabs && tabs.map((t, i) => <li key={`productTab${i}`} className={`productTab ${"tab-"+(i+1) == sel ? "current" : ""}`} data-tab={`tab-${i + 1}`} onClick={(e) => {selectTab(e)}}>{t}</li>)}
            </ul>
            
        );
    })

    return (
        <div className="bookInformationSection">
            <Tabs />
            <div className="tabContainer">
                {tabs && tabs.map((t, i) => getPanel(t, i + 1))}
            </div>
        </div>
    );
}

export default BookPageTabs;